var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "-2 2 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57576 0C8.65455 0 11.1515 2.49697 11.1515 5.57576V15.7576C11.1515 15.903 11.0545 16 10.9091 16H0.242424C0.0969697 16 0 15.903 0 15.7576V5.57576C0 2.49697 2.49697 0 5.57576 0ZM10.6667 5.81818V5.57576C10.6667 2.76364 8.38788 0.484848 5.57576 0.484848C2.76364 0.484848 0.484848 2.76364 0.484848 5.57576V13.0909H2.18182V10.9091C2.18182 10.7636 2.27879 10.6667 2.42424 10.6667H4.36364V8.48485C4.36364 8.33939 4.46061 8.24242 4.60606 8.24242H6.54545V6.06061C6.54545 5.91515 6.64242 5.81818 6.78788 5.81818H10.6667ZM0.484848 13.5758V15.5152H10.6667V13.5758H0.484848ZM2.66667 11.1515V13.0909H10.6667V11.1515H2.66667ZM4.84848 8.72727V10.6667H10.6667V8.72727H4.84848ZM7.0303 6.30303V8.24242H10.6667V6.30303H7.0303Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCave);
export default __webpack_public_path__ + "static/media/cave.7659481e.svg";
export { ForwardRef as ReactComponent };